import {
    default as newFetcher,
    MethodEnum,
} from 'utils/helpers/browser/newFetcher';
import { AnonymousPaymentDataInterface } from 'submodules/api_middleware/src/interfaces/api/AnonymousPaymentDataInterface';

/**
 * Gets personal payment data for given member identified by member id and birth number.
 * @param memberId internal member ID - used within organization
 * @param nationalId member identification (birth number)
 */
export const getAnonymousPaymentDetails = async (
    memberId: string,
    nationalId: string
): Promise<AnonymousPaymentDataInterface> => {
    return newFetcher('/api/anonymous-payment/payment-data', MethodEnum.GET, {
        memberId: memberId,
        nationalIdentifier: nationalId,
    });
};
